import React, { useState, useEffect, useRef } from 'react';
import PasswordStrengthBar from 'react-password-strength-bar';

import {
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button,
  Typography, TextField, Grid, Box, Select, MenuItem, Divider, Switch,
  InputAdornment, IconButton, FormControl, FormHelperText, Alert,
  CircularProgress
} from '@mui/material';

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { styled } from '@mui/material/styles';

import { addNewMonitoringUser, } from "apis/CustomersApis";
import colors from "assets/mavric-theme/base/colors.js";
import typography from "assets/mavric-theme/base/typography";
import borders from "assets/mavric-theme/base/borders";
const { borderRadius } = borders;
const { primary, secondary, text, transparent } = colors;
const { size } = typography;

import { getKeyValue, digestMessage, hasKeyName, isEmptyObject, validateName, validateEmail, removeAllSpaces, toPascalCase } from "common_utils/utils";
import { Phone } from '@mui/icons-material';
import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/material.css';

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 38,
  height: 21,
  padding: 0,
  display: "flex",
  alignItems: "center",
  marginTop: "0.001px",

  "& .MuiSwitch-switchBase": {
    padding: 1,
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#34C759",
        opacity: 1,
        border: 0,
      },
      "& .MuiSwitch-thumb": {
        backgroundColor: "#1295ED", // Blue 
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "4px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: theme.palette.grey[100],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.3,
    },
  },

  "& .MuiSwitch-thumb": {
    width: 18,
    height: 18,
    marginTop: "0.1px",
    backgroundColor: "#fff",
    boxShadow: "0 1px 2px 0 rgb(0 35 11 / 20%)",
    transition: theme.transitions.create(["width", "background-color"], {
      duration: 200,
    }),
  },

  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    backgroundColor: "#E9E9EA",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 200,
    }),
    width: 38,
    height: 21,
  },
}));

const MonitorUserTableDialog = ({ formData, open, handleClose, userRoleList }) => {

  const initialUserInfo = { user_id: 0, customer_id: 0, role_id: 3, email: "", password: "", phone: "", first_name: "", last_name: "", mosaic_view_enabled: false };
  const [userInfo, setUserInfo] = useState(initialUserInfo);
  const [usrFName, setUsrFName] = useState(userInfo.first_name);
  const [usrLName, setUsrLName] = useState(userInfo.last_name);
  const [usrRoleId, setUsrRoleId] = useState(userInfo.role_id);
  const [usrEmail, setEmailAddr] = useState(userInfo.email);
  const [usrPhoneNumber, setUsrPhoneNumber] = useState(userInfo.phone);
  const [enabledMosaicView, setEnabledMosaicView] = useState(false);
  const [enabledIOMatrix, setEnabledIOMatrix] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [userPassword, setPassword] = useState("");
  const [enableActionBtn, setEnableActionBtn] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showInProcess, setShowInProcess] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [compError, setError] = useState("");
  //Dialog for Success Okay.
  const [ConfirmOpen, setConfirmOpen] = useState(false);
  const [MessageConfirm, setMessageConfirm] = useState("");
  const [MessageConfirmTitle, setMessageConfirmTitle] = useState("");
  const [formAction, setFormAction] = useState("Add");
  const [customerId, setCustomerId] = useState(0);


  useEffect(() => {
    let initCustomerId = getKeyValue(formData, "customer_id", 0);
    setCustomerId(initCustomerId);
  }, [formData]);


  useEffect(() => {
    setShowInProcess(loading);
    setEnableActionBtn(!loading);

  }, [loading]);



  useEffect(() => {
    setShowInProcess(false);
    setEnableActionBtn(!showResult);
  }, [showResult]);


  useEffect(() => {
  }, [usrFName, usrEmail, usrLName, userInfo, userPassword, customerId, usrRoleId]);


  const onChangeEnableMosaicView = (e) => {
    let isChecked = e.target.checked;
    setError(null);
    setEnabledMosaicView(isChecked);

  }

  const onChangeEnableIOMatrix = (e) => {
    let isChecked = e.target.checked;
    setError(null);
    setEnabledIOMatrix(isChecked);

  }


  const handleChange = (event) => {

    setError(null);
    switch (event.target.name) {
      case 'usrEmail':
        let usrEmail = event.target.value;
        usrEmail = removeAllSpaces(usrEmail)
        setEmailAddr(usrEmail);
        userInfo.email = usrEmail;
        setUserInfo(userInfo);
        break;
      case 'usrFName':
        let usrFName = event.target.value;
        usrFName = removeAllSpaces(usrFName)
        setUsrFName(usrFName);
        userInfo.first_name = usrFName;
        setUserInfo(userInfo);
        break;
      case 'usrLName':
        let usrLName = event.target.value;
        usrLName = removeAllSpaces(usrLName);
        setUsrLName(usrLName);
        userInfo.last_name = usrLName;
        setUserInfo(userInfo);
        break;
    }

    checkForm(userInfo);
  };


  const handleNewUser = (userInfo) => {
    userInfo.formAction = formAction;
    addNewMonitoringUser(userInfo)
      .then((result) => {

        console.log("addNewMonitoringUser : result: ", result);

        let userId = 0;
        setError(null);

        if (hasKeyName(result, "user_id")) {
          userId = parseInt(result.user_id);
          setIsSuccess((userId > 0) ? true : false);
          setUserInfo(initialUserInfo);
          if (userId > 0) {
            setMessageConfirmTitle("Successfully added user.");
            setConfirmOpen(true);
          }
        }
        else {
          setError("User Id key failed.");
          setIsSuccess(false);
        }
        setShowResult(true);
      }).catch((error) => {
        if (error.response && error.response.data && error.response.data.message) {
          let msg = error.response.data.message;
          if(typeof msg === "string" && msg.includes("User with email already exist")){
            setError("User is already exists.");
          } else {
            setError("An error occurred while adding the user.");
          }
        } else {
          setError("An error occurred while adding the user.");
        }
        setLoading(false);
      });

  };

  const validateForm = (userInfo) => {

    if (!(hasKeyName(userInfo, "first_name") &&
      hasKeyName(userInfo, "last_name") &&
      hasKeyName(userInfo, "email") &&
      hasKeyName(userInfo, "role_id") &&
      hasKeyName(userInfo, "password") &&
      hasKeyName(userInfo, "customer_id") &&
      hasKeyName(userInfo, "mosaic_view_enabled"))
    ) return false;

    if (isEmptyObject(userInfo.password) || isEmptyObject(userInfo.email)) return false;

    return validateEmail(userInfo.email);

  };

  const handleSubmitForm = () => {

    let newUserInfo;

    newUserInfo = {
      first_name: usrFName,
      last_name: usrLName,
      email: usrEmail,
      phone: usrPhoneNumber,
      password: userPassword,
      role_id: usrRoleId,
      mosaic_view_enabled: enabledMosaicView,
      iomatrix_switch_enabled: enabledIOMatrix,
      customer_id: parseInt(customerId)
    }

    if (validateForm(newUserInfo)) {
      setLoading(true);
      digestMessage(userPassword).then(newHashPswd => {
        newUserInfo.password = newHashPswd;
        handleNewUser(newUserInfo);
      });

    } else {
      console.log("Form validation failed");
      setError("Form validation failed. Please check the values before submitting.");
    }

  };

  const handlePhoneChange = (value) => {
    let usrPhoneNumber = removeAllSpaces("+" + value);
    //console.log(usrPhoneNumber);
    setUsrPhoneNumber(usrPhoneNumber);
    userInfo.phone = usrPhoneNumber;
    setUserInfo(userInfo);
    // checkForm(userInfo);
  };

  const checkForm = (userInfo) => {
    setEnableActionBtn(
      userInfo.first_name && userInfo.first_name.trim().length > 0 && 
      validateEmail(userInfo.email) && 
      userPassword.length > 3
    );
  };

  const handleTogglePassword = () => setShowPassword(showPassword => !showPassword);

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    setError(null);
    checkForm(userInfo);
  };


  const handleConfirmClose = () => {
    setConfirmOpen(false);
    setUserInfo(initialUserInfo);
    setUsrFName("");
    setUsrLName("");
    setEmailAddr("");
    setUsrPhoneNumber("");
    setPassword("");
    setEnabledMosaicView(false);
    setShowInProcess(false);
    setShowResult(false);
    setUsrRoleId(3);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" sx={{ '& .MuiDialog-paper': { backgroundColor: primary.main, } }}>
      <DialogTitle>
        <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, mb: 1 }} gutterBottom> Add Monitoring User Data </Typography>
      </DialogTitle>

      <DialogContent>
        <Grid container>
          <Typography variant="body2" fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 400, mb: 1 }}>
            Customer Name :&nbsp;{formData ? (formData.org_name !== null ? formData.org_name : '') : ''}
          </Typography>
        </Grid>

        <Divider sx={{ borderColor: primary.divider, mt: 2, mb: 2 }} />
        <Grid container spacing={2} direction="row">
          <Grid item xs={12} sm={4} md={4} lg={4} >
            <Typography variant="body2" fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 400, marginBottom: '8px' }} >
              First Name
            </Typography>
            <TextField
              required
              id='txtFldUsrFName'
              name='usrFName'
              placeholder='First Name'
              value={usrFName !== null && usrFName !== undefined ? usrFName : ''}
              onChange={handleChange}
              fullWidth
              type={'text'}
              InputProps={{ readOnly: false, sx: { color: text.main }, inputProps: { min: 1, max: 200, }, }}
              sx={{ color: text.main, borderColor: primary.focus, backgroundColor: transparent.main, borderRadius: borderRadius.md, }}
              InputLabelProps={{
                sx: { color: text.main },
              }}
            />
          </Grid>

          <Grid item xs={12} sm={4} md={4} lg={4} >
            <Typography variant="body2" fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 400, marginBottom: '8px' }} >
              Last Name
            </Typography>
            <TextField
              id='txtFldUsrLName'
              name='usrLName'
              placeholder='Last Name'
              value={usrLName !== null && usrLName !== undefined ? usrLName : ''}
              onChange={handleChange}
              fullWidth
              type={'text'}
              InputProps={{ readOnly: false, sx: { color: text.main }, inputProps: { min: 1, max: 200, }, }}
              sx={{ color: text.main, borderColor: primary.focus, backgroundColor: transparent.main, borderRadius: borderRadius.md, }}
              InputLabelProps={{ sx: { color: text.main }, }}
            />
          </Grid>

          <Grid item xs={12} sm={4} md={4} lg={4} >

            <Typography variant="body2" fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 400, marginBottom: '8px' }} >
              Email Address*
            </Typography>
            <TextField
              required
              id={`txtFldUsrEmail`}
              name="usrEmail"
              value={usrEmail}
              onChange={handleChange}
              fullWidth
              autoComplete="off"
              InputProps={{ readOnly: false, sx: { color: text.main }, inputProps: { min: 1, max: 200, }, }}
              sx={{ color: text.main, borderColor: primary.focus, backgroundColor: transparent.main, borderRadius: borderRadius.md, }}
              placeholder="Email Address"
              InputLabelProps={{ sx: { color: text.main }, }}
            />
            <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={secondary.main} sx={{ fontWeight: 400, }}>Note: This will be the user's Login Id.</Typography>
          </Grid>

          <Grid item xs={12} sm={4} md={4} lg={4}>
            <Typography variant="body2" fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 400, marginBottom: '8px' }}>
              Phone Number
            </Typography>
            <PhoneInput
              id={`txtFldUsrPhoneNumber`}
              name="usrPhoneNumber"
              value={usrPhoneNumber}
              onChange={handlePhoneChange}
              fullWidth
              dropdownStyle={{ margin: '0px', backgroundColor: "primary.focus" }}
              country={'us'}
              autoComplete="off"
              InputProps={{ readOnly: false, sx: { color: text.main } }}
              specialLabel=''
              sx={{
                color: text.main,
                borderColor: primary.focus,
                // backgroundColor: transparent.main,
                // backgroundColor: '#EFEFEF',
                borderRadius: borderRadius.md
              }}
              placeholder="Enter phone number"
              inputStyle={{ width: '100%', height: '45px', backgroundColor: '#EFEFEF', marginTop: '3px' }}
            />
          </Grid>

          {/* Role Type */}
          <Grid item xs={12} sm={4}>
            <Typography variant="body2" fontSize={size.sm} sx={{ fontWeight: 400, marginBottom: '8px' }}>
              Role Type
            </Typography>
            <Select
              id="usrRoleId"
              name="usrRoleId"
              value={usrRoleId}
              onChange={(e) => setUsrRoleId(e.target.value)}
              displayEmpty
              fullWidth
              sx={{
                '.MuiSelect-select': {
                  paddingTop: '8px !important',
                  paddingBottom: '8px !important',
                  minHeight: '35px !important',
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '1em !important'
                }
              }}
            >
              {userRoleList.map((item, idx) => (
                <MenuItem key={idx} value={item.id}>
                  {toPascalCase(item.role)}
                </MenuItem>
              ))}
            </Select>
          </Grid>

          <Grid item xs={12} sm={4} md={4} lg={4} >
            <Typography variant="body2" fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 400, marginBottom: '8px' }} >
              Password*
            </Typography>
            <TextField
              required
              id="filled-password-input"
              name="usrPassword"
              type={showPassword ? "text" : "password"}
              variant="outlined"
              onChange={handlePasswordChange}
              // sx={{ width: 300 }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleTogglePassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOffIcon color="secondary" /> : <VisibilityIcon color="secondary" />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              size="small"
              // sx={{ width: 200}}
              placeholder="Password"
            />
            <PasswordStrengthBar password={userPassword} />

          </Grid>

          <Grid item xs={12} sm={4} >
            <Typography
              variant="body2"
              fontSize={size.md}
              color={text.main}
              sx={{ fontWeight: 400, marginBottom: '8px' }}
            >
              Mosaic View
            </Typography>

            <Grid container direction="row" alignItems="center">
              <Grid item>
                <AntSwitch
                  name="chkUsrMosaicView"
                  checked={enabledMosaicView}
                  onChange={onChangeEnableMosaicView}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
              </Grid>
              <Grid item>
                <Typography
                  variant="body2"
                  fontSize={size.md}
                  color={text.main}
                  sx={{ fontWeight: 400, marginLeft: '4px' }}
                >
                  {enabledMosaicView ? 'Enable' : 'Disable'}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          {/* <Grid item>
            {(compError) && (
              <Alert variant="filled" severity="error" onClick={() => setError(undefined)} sx={{ py: 0 }}>
                <Typography fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>{compError}</Typography>
              </Alert>
            )}
          </Grid> */}
          <Grid item xs={12} sm={4} >
            <Typography
              variant="body2"
              fontSize={size.md}
              color={text.main}
              sx={{ fontWeight: 400, marginBottom: '8px' }}
            >
              Preset Switch
            </Typography>

            <Grid container direction="row" alignItems="center">
              <Grid item>
                <AntSwitch
                  name="chkUsrIOMatrix"
                  checked={enabledIOMatrix}
                  onChange={onChangeEnableIOMatrix}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
              </Grid>
              <Grid item>
                <Typography
                  variant="body2"
                  fontSize={size.md}
                  color={text.main}
                  sx={{ fontWeight: 400, marginLeft: '4px' }}
                >
                  {enabledIOMatrix ? 'Enable' : 'Disable'}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={4} ></Grid>
          <Grid item>
            {(compError) && (
              <Alert variant="filled" severity="error" onClick={() => setError(undefined)} sx={{ py: 0 }}>
                <Typography fontSize={size.sm} color={text.focus} sx={{ fontWeight: 400 }}>{compError}</Typography>
              </Alert>
            )}
          </Grid>
          <Grid item>
            <Dialog open={ConfirmOpen} onClose={handleConfirmClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description"
              sx={{
                '& .MuiDialog-paper': {
                  backgroundColor: primary.main,
                }
              }}
            >
              <DialogTitle id="alert-dialog-title">
                <Typography fontSize={size.lg} color={text.main} sx={{ fontWeight: 600, }}>{MessageConfirmTitle}</Typography>
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">{MessageConfirm}</DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button variant="contained" color="secondary" onClick={handleConfirmClose} autoFocus>OK</Button>
              </DialogActions>
            </Dialog>
          </Grid>


        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary" variant="contained" sx={{ borderRadius: "4px", padding: "10px 20px", }}>
          Cancel
        </Button>
        <Button onClick={handleSubmitForm} color="secondary" variant="contained" disabled={!enableActionBtn} sx={{ borderRadius: "4px", padding: "10px 20px", }}  >
          Save
        </Button>

        {showInProcess
          ? <CircularProgress color="secondary" />
          : null
        }

        {showResult
          ? (isSuccess
            ? <CheckCircleIcon />
            : <CancelIcon />)
          : null
        }
      </DialogActions>
    </Dialog >
  );
};

export default MonitorUserTableDialog;
